<template>
  <div>
    <AuBreadcrumb :pages="breadcrumb" />
    <ProgressLoader
      v-if="loading"
      mode="indeterminate"
      color="#5AC396"
      size="150px"
    />
    <div
      v-show="!loading"
      id="myDomId"
      class="card"
    />
  </div>
</template>

<script>
import ProgressLoader from "@/loaders/progress-bar";
import SwaggerUI from "swagger-ui";
import { mapActions } from "vuex";
import "swagger-ui/dist/swagger-ui.css";

export default {
  name: "Swagger",
  components: { ProgressLoader },
  data() {
    return {
      loading: true,
      breadcrumb: [
        { key: 0, name: this.$t("router.pages.dashboard"), path: "/" },
        {
          key: 2,
          name: this.$t("router.pages.myPlatforms"),
          path: "/my-platforms"
        }
      ]
    };
  },
  async mounted() {
    this.loading = true;
    const resp = await this.getPlatformDocs();
    this.loading = false;
    const spec = resp.data;
    SwaggerUI({
      spec: spec,
      dom_id: "#myDomId"
    });
  },
  methods: {
    ...mapActions({
      getPlatformDocs: "platforms/getPlatformDocs"
    })
  }
};
</script>

<style scoped lang="scss"></style>